import React, { useState } from "react";
import "./Query_Form.css";
import { Form } from "react-bootstrap";
import RedRoundBtn from "../../../Common_Component/Common_Btn/RedRoundBtn/RedRoundBtn";
import Contact_Success_Modal from "../../../Common_Component/Common_Modal/Contact_Success_Modal/Contact_Success_Modal";
import { useForm } from "react-hook-form";
import { FaqQueryForm } from "../../../../utils/apis/form/form";

const Query_Form = (props) => {
  const [shwoModal, setShowModal] = useState(false);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const onSubmit = async (data) => {
    const formData = new FormData();

    formData.append("message", data?.message);

    const res = await FaqQueryForm(formData);
    if (res?.success) {
      reset();
      setShowModal(true);
    } else {
    }
  };
  return (
    <section className="Query_Form">
      <div className="content_holder">
        <div className="img_holder">
          <img src="\assets\Image\FAQ\img.png" className="faq_img" />
        </div>
        <p className="title_label">Any Questions?</p>
        <p className="subtext_label">
          We are here for you, until your doubts are cleared!
        </p>
      </div>

      <div className="form_holder">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group>
            <Form.Control
              type="text"
              aria-label="Small"
              aria-describedby="inputGroup-sizing-sm"
              as={"textarea"}
              placeholder="Write your message here"
              name="message"
              {...register("message", {
                required: "Message is required",
              })}
            />
            {errors?.message && (
              <span className="invalid-feedback d-block">
                {errors.message.message}
              </span>
            )}
          </Form.Group>

          <div className="btn_holder">
            <RedRoundBtn
              type="submit"
              btn_name="Submit"
              // onClick={() => {
              //   setShowModal(true);
              // }}
            />
          </div>
        </Form>
      </div>

      {shwoModal && (
        <Contact_Success_Modal
          show={shwoModal}
          onHide={() => {
            setShowModal(false);
          }}
          title="Glad to know your interest to explore!"
          subtitle="Soon we will get back to you!"
        />
      )}
    </section>
  );
};

export default Query_Form;
